import React from 'react';
import IntlMessage from "../../../../components/IntlMessage/IntlMessage";
import {Flex, Tabs} from "antd";
import MyText from "../../../../components/UI/Text/MyText";
import OrderList from "./List/OrderList";
import OrderCreateNew from "./Creation/OrderCreateNew";

const OrdersPage = () => {

    const tabItems = [
        {
            key: '1',
            label: <IntlMessage id={'list'}/>,
            children: <OrderList/>,
        },
        {
            key: '2',
            label: <IntlMessage id={'creation'}/>,
            children: <OrderCreateNew/>,
        },
    ]

    return (
        <Flex style={{width: "100%"}} align={"flex-start"} justify={"flex-start"} vertical gap={20}>
            <MyText uppercase strong size={"large"}><IntlMessage id={'orders'}/></MyText>
            <Tabs style={{width: "100%"}} defaultActiveKey={"1"} type="card" items={tabItems}/>
        </Flex>
    );
};

export default OrdersPage;